export const currentVersion = "3.4.4";
export const buildNumber = 1;

// Keep the footer format stable: "Datavision {version} {copyright} [ {customerId} ]"
export const copyrightText = `© 2022 - ${new Date().getFullYear()}`;

/**
 * Changelog entries for the current year (since Jan 1st).
 * IMPORTANT: Do NOT include changes related to:
 * - /calculations
 * - /price-calculator
 */
export const changelogEntries = [
  {
    section: "Prístupový systém – lístky",
    items: [
      "Pridaný nový stav lístka „Nezaplatené“ (vizuálne odlíšenie v zozname aj detaile).",
      "Zobrazenie platnosti lístka je zjednotené a doplnené o presný čas (vrátane sekúnd) v náhľade aj v detaile.",
      "Aktivity lístka v detaile sú zoradené od najnovšej po najstaršiu pre rýchlejšiu orientáciu.",
      "Vyhľadávanie lístkov používa aktualizovaný endpoint pre prístupový systém.",
    ],
  },
  {
    section: "Prístupový systém – nastavenia",
    items: [
      "Pridaná samostatná sekcia v bočnom menu pre prístupový systém a jeho nastavenia.",
      "Doplnená stránka nastavení tlače (text pred/za lístkami) s validáciou a možnosťou resetu na predvolené hodnoty.",
    ],
  },
  {
    section: "Používatelia (DSOK)",
    items: [
      "Nová sekcia Používatelia so zoznamom a detailom (pridanie / úprava).",
      "Email je povinný a pri úprave existujúceho používateľa je iba na čítanie.",
      "Stav používateľa (Aktívny/Neaktívny) je prehľadne zobrazený a spravovateľný; zmazanie funguje ako deaktivácia.",
      "Doplnené breadcrumbs a rýchla navigácia do používateľov z hlavičky aplikácie.",
    ],
  },
  {
    section: "Objednávky (/customer/dsok/orders)",
    items: [
      "Opravené stavové ikony pre stav objednávky, platbu, POS terminál a E‑KASA tak, aby neukazovali falošné OK stavy.",
      "Zjednotené mapovanie stavov do jednej logiky (konzistentné ikony v zozname aj v detaile).",
      "Vylepšené zarovnanie a konzistentné šírky stĺpcov v zozname objednávok (stabilný layout bez posúvania).",
    ],
  },
  {
    section: "Detail objednávky (modal)",
    items: [
      "Ikony POS terminálu a E‑KASA sú konzistentné v prehľade aj v záložkách.",
      "Zľavy sa zobrazujú ako položky priamo v tabuľke produktov (pod produktmi, pred DPH riadkami).",
      "Opravená konzistentnosť DPH a súčtov tak, aby nevznikali rozdiely o 0,01 € medzi riadkami DPH a „Spolu“.",
    ],
  },
  {
    section: "Cenník – tlač / export",
    items: [
      "Popisy produktov v stĺpci „Popis“ sa zobrazujú celé (bez skracovania a bez trojbodky).",
      "Pridaná hlavička (logo DataVision + názov cenníka) a pätička s firemnými údajmi a platnosťou od 1.1. aktuálneho roka na každú stranu.",
      "Zabezpečené, aby sa pri tlači/exporte negenerovali prázdne strany.",
    ],
  },
  {
    section: "Denné menu (DSOK)",
    items: [
      "Pridaný modul pre správu a zobrazenie denného menu.",
      "Vylepšené zobrazenia pre rôzne režimy (zoznam / grid, portrait / landscape) a nastavenia obrazovky.",
      "Aktualizácie obsahu prebiehajú spoľahlivejšie aj vďaka real‑time refreshu.",
    ],
  },
  {
    section: "Zľavy a pravidlá košíka (DSOK)",
    items: [
      "Doplnené automatické zľavy a vylepšené pravidlá košíka (kupóny) pre lepšiu správu akcií.",
    ],
  },
  {
    section: "Administrácia a navigácia",
    items: [
      "Podpora multi‑store (viac prevádzok) a úpravy navigácie v bočnom menu pre rýchlejší prístup k modulom.",
    ],
  },
  {
    section: "Kategórie (DSOK)",
    items: [
      "Vylepšenia zobrazenia detailu kategórie a práce s kódom kategórie.",
    ],
  },
  // --- Verzia 3.4 (zmeny od 3.3; bez /calculations a /price-calculator) ---
  {
    section: `Verzia 3.4 – 17.02.2026`,
    items: [
      "Zmeny od verzie 3.3 (bez modulov /calculations a /price-calculator).",
    ],
  },
  {
    section: "Pridané (Added)",
    items: [
      "Admin Dashboard: nová obrazovka pre rolu Admin (prehľad systému, KPI karty, zdravie a problémy, nedávna aktivita).",
      "Admin Dashboard: napojenie na backend endpoint /api/V1/dashboard s parametrami caller, severity, status, limitProblems, limitActivity.",
      "Tlačidlo „Login“ v detaili zákazníka DSOK – prihlásenie ako zákazník (iba pre Admin).",
      "POS integrácia v základoch nastavení zákazníka (Základné nastavenie) – výber typu (ikelp, dotykacka, oberon, storyous, agnis).",
      "Sekcia Preklady v nastaveniach zákazníka: editor, import/export prekladow, sticky layout.",
    ],
  },
  {
    section: "Zmenené (Changed)",
    items: [
      "Admin po prihlásení presmerovaný na /admin/dashboard ako východziu stránku.",
      "Changelog v pätičke je viditeľný len pre používateľa s ID = 1 (Admin).",
      "Partner a Service Partner vidia všetky zariadenia zákazníka (bez filtrovania podľa typu).",
      "Odstránená sekcia Údržba z menu detailu zákazníka DSOK.",
      "Odstránené označenia „Admin view“, „Partner view“ a pod. v detailoch zákazníka.",
    ],
  },
  {
    section: "Opravené (Fixed)",
    items: [
      "Aktualizácia nastavení na stránke Preklady – sekcia „translations“ zapísaná do section config a payloadu.",
      "Kiosk náhľad pre demo zariadenia dostupný pre Partner a Customer (tlačidlo v závislosti od typu).",
    ],
  },
  // --- Verzia 3.4.1 (multi-step form, preview, stepper) ---
  {
    section: `Verzia 3.4.1 – 18.02.2026`,
    items: [
      "Multi-step formulár vytvorenia zákazníka (kroky: Základné nastavenie, Licencia, Lokalita, Kiosky).",
      "Vylepšená navigácia krokov – klikateľné kruhy, validácia pri postupe vpred, spätná navigácia bez validácie.",
      "Stepper UI – čísla v kruhoch, hover efekt, zvýraznenie aktívneho a dokončených krokov.",
      "Náhľad zákazníka (Preview) v zozname DSOK zákazníkov – modal so sekciami (spoločnosť, nastavenie, prevádzka, webview).",
      "Prostredie v náhľade: DEV1 pre staging, PROD1 pre production.",
      "Webview URL v náhľade – klikateľný odkaz, otvorenie v novom okne; zobrazenie len pri demo zariadení.",
      "Predvolené hodnoty v kroku Licencia (Backend doména, Frontend, Obchodný partner Simpleo, typ licencie, atď.).",
      "Opravy a vylepšenia UI.",
    ],
  },
  // --- Verzia 3.4.2 (vernostný systém, loyalty pricing) ---
  {
    section: "Verzia 3.4.2 – 19.02.2026",
    items: [
      "Nastavenia aplikácie: nová záložka „Vernostný systém“ – zapnutie vernostného systému (isEnabled), výber typu (žiadny / Datavision / VEXiON), pole BusinessId pre VEXiON.",
      "Detail produktu: nová sekcia „Vernostný program“ pred „Časové ceny“ – tri úrovne cien (Úroveň 1–3), údaje v product.loyaltyData, automatický prefix translationCode pre VEXiON (vexionLevel1/2/3).",
      "Detail produktu: pri vernostnom programe typ zľavy pre každú úroveň (Suma alebo Percento), pri percente povinné percento a automatický prepočet zľavnenej ceny zo základnej ceny produktu.",
    ],
  },
  // --- Verzia 3.4.3 (price-calculator CZ mena, ponuka v Kč) ---
  {
    section: "Verzia 3.4.3 – 20.02.2026",
    items: [
      "Kalkulačka cien: pre trh CZ pridaný kurz CZK/EUR (predvolene 25) a prepínač zobrazenia meny (EUR / Kč); všetky ceny v kalkulačke sa pri Kč prepočítavajú na celé Kč.",
      "Kalkulačka cien: vygenerovaná cenová ponuka (quote) sa pri zvolenom Kč zobrazuje v Kč (kurz a mena sa ukladajú do snapshotu).",
      "Kalkulačka cien: responzívne karty zariadení, max 4 zariadenia v riadku, odkaz Detail pod popisom, zobrazenie počtu produktov v zozname.",
    ],
  },
  // --- Verzia 3.4.4 (FAQ produkty/kategórie, objednávky UI, sticky kalkulačka, farby tlačidla objednať) ---
  {
    section: "Verzia 3.4.4 – 21.02.2026",
    items: [
      "FAQ (Pre zákazníkov): nové témy „Manažment produktov“ a „Manažment kategórií“ – návody na vytvorenie a úpravu produktov a kategórií so zhodou s názvami v UI.",
      "Objednávky (/customer/dsok/orders): odstránený stĺpec pickup code; stav objednávky a stĺpce Platba/E-KASA, Spolu/typ platby a Obj.ID/Kód zúžené; Obj.ID a Kód zobrazené pod sebou pod stavom objednávky.",
      "Horné sticky menu: kalkulačka cien povolená pre customerType 7 (service partner).",
      "Farby zákazníka (Customer Colors): pridané polia „Pozadie tlačidla objednať“ (orderButtonBackgroundColor) a „Farba tlačidla objednať“ (orderButtonTextColor) s predvolenými #c0844d a #ffffff.",
    ],
  },
];
